<div>
  <section class="content">
    <app-upload
      [url]="url"
      (customUpload)="uploadWithGuidFileName($event)"
      (fileUploaded)="onFileUploaded($event)"
      [allowedFileType]="allowedFileType"
    ></app-upload>
    <app-grid-wrapper #grid [gridSize]="gridSize"> </app-grid-wrapper>
  </section>
</div>
